var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessingOmega3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ProcessingOmega3",
    "data-name": "ProcessingOmega3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#eaf3fa"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12663",
    "data-name": "Path 12663",
    d: "M754.8,592.256s-.733-4.685.94-5.879l-5.734-.443s.873,5.455,4.793,6.322",
    transform: "translate(-710.307 -522.904)",
    fill: "#b6cbe0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12664",
    "data-name": "Path 12664",
    d: "M753.644,591.023c-2.464-1.4-3.117-5.229-3.124-5.274l-1.525.245c.039.244,1.006,5.984,5.39,6.953a.715.715,0,0,0,.165.02.773.773,0,0,0,.764-.892c-.266-1.7-.251-4.507.626-5.131l-.9-1.259c-1.443,1.033-1.514,3.674-1.4,5.338",
    transform: "translate(-710.057 -522.843)",
    fill: "#6d6e71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12665",
    "data-name": "Path 12665",
    d: "M781.188,581.981l-7.949,2.071a21.658,21.658,0,0,0,8.277,4.065s-3.576-4.173-.327-6.137",
    transform: "translate(-716.049 -521.927)",
    fill: "#b6cbe0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12666",
    "data-name": "Path 12666",
    d: "M780.462,583.723a1.83,1.83,0,0,1,.964-1.3l-.8-1.323a3.373,3.373,0,0,0-1.692,2.38,5.3,5.3,0,0,0,.662,3.135,22.8,22.8,0,0,1-6.031-3.381l-.982,1.195a22.23,22.23,0,0,0,8.625,4.229.747.747,0,0,0,.146.015.773.773,0,0,0,.588-1.275c-.486-.568-1.7-2.34-1.481-3.676",
    transform: "translate(-715.887 -521.71)",
    fill: "#6d6e71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12667",
    "data-name": "Path 12667",
    d: "M755.028,554.826c-1.444,1.62-4.1,7.472-4.1,7.472l14.261.569a30.377,30.377,0,0,1-6.386-3.279,14.1,14.1,0,0,1-3.776-4.763",
    transform: "translate(-710.535 -515.216)",
    fill: "#b6cbe0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12668",
    "data-name": "Path 12668",
    d: "M755.5,554.243a.771.771,0,0,0-1.277-.185c-1.5,1.687-4.117,7.422-4.226,7.666l1.407.638a63.16,63.16,0,0,1,3.3-6.35,13.631,13.631,0,0,0,3.419,3.949,30.828,30.828,0,0,0,6.576,3.377l.526-1.452a29.841,29.841,0,0,1-6.195-3.176,13.43,13.43,0,0,1-3.531-4.467",
    transform: "translate(-710.304 -514.962)",
    fill: "#6d6e71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12669",
    "data-name": "Path 12669",
    d: "M772.037,564.186l5.636,1.316c-2.05-.492,1.361-5.336,1.361-5.336-2.042.556-7,4.02-7,4.02",
    transform: "translate(-715.751 -516.536)",
    fill: "#b6cbe0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12670",
    "data-name": "Path 12670",
    d: "M778.687,559.167c-2.147.584-7.031,3.989-7.237,4.134l.884,1.265c.9-.626,2.9-1.958,4.6-2.907-.587,1.162-1.044,2.486-.711,3.374a1.547,1.547,0,0,0,1.129.968l.32-1.506c-.214-.389.547-2.28,1.854-4.139a.772.772,0,0,0-.834-1.189",
    transform: "translate(-715.606 -516.282)",
    fill: "#6d6e71"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12671",
    "data-name": "Path 12671",
    d: "M800.35,571.365l-.485,1.489c1.73,4.652,7.95,10.066,7.95,10.066-1.089-1.575-3.377-10.621-3.377-10.621l4.76-10.619c-1.909,1.225-6.436,6.533-8.849,9.685",
    transform: "translate(-722.629 -516.91)",
    fill: "#b6cbe0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12672",
    "data-name": "Path 12672",
    d: "M808.544,560.774c-2,1.283-6.58,6.646-9.046,9.868l1.227.938c1.616-2.11,4.033-5,6.012-7.087l-3.244,7.236a.761.761,0,0,0-.041.505c.156.616,1.119,4.392,2.084,7.382-1.872-1.951-4.247-4.76-5.186-7.286l-1.449.539c1.78,4.781,7.909,10.152,8.168,10.379a.774.774,0,0,0,1.144-1.024c-.717-1.035-2.312-6.636-3.2-10.109l4.65-10.375a.773.773,0,0,0-1.122-.967",
    transform: "translate(-722.391 -516.655)",
    fill: "#6d6e71"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12673",
    "data-name": "Path 12673",
    d: "M747.2,564.946c-13.122,1.01-19.623,9.061-19.623,9.061,4.9,3.73,13.008,6.776,20.79,7.11,9.628.409,18.745-2.5,25.581-4.622s10.077-3.453,10.077-3.453c-14.015-6.5-27.074-8.847-36.825-8.1",
    transform: "translate(-704.765 -517.684)",
    fill: "#dbe5ef"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12674",
    "data-name": "Path 12674",
    d: "M757.947,575.509a80.734,80.734,0,0,1-19.774,3.9,40.719,40.719,0,0,0,12.816,2.786c9.628.409,18.745-2.5,25.581-4.621s10.078-3.453,10.078-3.453a98.394,98.394,0,0,0-12.891-4.937,91.859,91.859,0,0,1-15.809,6.323",
    transform: "translate(-707.382 -518.765)",
    fill: "#b6cbe0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12675",
    "data-name": "Path 12675",
    d: "M784.135,571.611c-11.6-5.378-23.568-8.34-33.708-8.34-1.262,0-2.5.046-3.694.139-13.466,1.035-20.158,9.144-20.436,9.488a1.157,1.157,0,0,0,.2,1.65c5.439,4.139,13.856,7.02,21.441,7.348.638.026,1.27.038,1.9.038,8.9,0,17.056-2.533,23.61-4.57l.462-.142c6.806-2.11,10.042-3.431,10.173-3.486a1.158,1.158,0,0,0,.048-2.125m-10.907,3.4-.463.144c-6.852,2.128-15.506,4.819-24.726,4.427a38.819,38.819,0,0,1-19.092-6.121,28.846,28.846,0,0,1,17.965-7.737c1.129-.085,2.313-.13,3.515-.13,9.069,0,19.688,2.466,30.169,6.978-1.654.59-4.1,1.426-7.368,2.439",
    transform: "translate(-704.384 -517.303)",
    fill: "#6d6e71"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12676",
    "data-name": "Path 12676",
    d: "M744.8,569.428a.58.58,0,0,0-.15.807,6.458,6.458,0,0,1-.432,7.857.58.58,0,0,0,.063.818.575.575,0,0,0,.815-.062,7.616,7.616,0,0,0,.509-9.268.581.581,0,0,0-.806-.152",
    transform: "translate(-708.843 -518.8)",
    fill: "#6d6e71"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12677",
    "data-name": "Path 12677",
    d: "M739.711,573.956a1.155,1.155,0,1,0,1.166,1.156,1.163,1.163,0,0,0-1.166-1.156",
    transform: "translate(-707.474 -519.943)",
    fill: "#b6cbe0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12678",
    "data-name": "Path 12678",
    d: "M739.521,573.187a1.735,1.735,0,1,0,1.745,1.735,1.741,1.741,0,0,0-1.745-1.735m0,2.309a.575.575,0,1,1,.586-.574.581.581,0,0,1-.586.574",
    transform: "translate(-707.284 -519.754)",
    fill: "#6d6e71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingOmega3);
export default __webpack_public_path__ + "static/media/ProcessingOmega3.caf43a38c77c58b598a04e9bc7409908.svg";
export { ForwardRef as ReactComponent };